import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN'
  }).format(amount);
};

export const formatDate = (dateString) => {
  if (dateString === null || dateString === undefined || dateString === '') return '—';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '—';
  const isDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(dateString);
  if (isDateOnly) {
    return new Intl.DateTimeFormat('es-MX', {
      day: '2-digit', month: 'long', year: 'numeric', timeZone: 'UTC'
    }).format(date);
  }
  return new Intl.DateTimeFormat('es-MX', {
    day: '2-digit', month: 'long', year: 'numeric'
  }).format(date);
};

export const formatDateTime = (dateString) => {
  if (dateString === null || dateString === undefined || dateString === '') return '—';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat('es-MX', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'UTC'
  }).format(date);
};

export const getInitials = (name) => {
  if (!name) return '??';
  return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
};

export const leadSourceColors = {
  facebook: 'bg-blue-500',
  instagram: 'bg-pink-500',
  whatsapp: 'bg-green-500',
  linkedin: 'bg-blue-700',
  youtube: 'bg-red-500',
  tiktok: 'bg-black',
  website: 'bg-purple-500',
  referido: 'bg-orange-500',
  manual: 'bg-gray-500',
  'Llamada en frío': 'bg-gray-500'
};

export const leadStatusColors = {
  nuevo: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300',
  contactado: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300',
  en_negociacion: 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300',
  ganado: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
  perdido: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300',
  pendiente_de_pago: 'bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-300'
};

export const roleLabels = {
  admin: 'Administrador',
  agente: 'Agente',
  aspirante: 'Aspirante',
  usuario: 'Asesor',
  asesor: 'Asesor',
  viewer: 'Viewer',
  developer: 'Desarrollador',
  asistente: 'Asistente',
  master: 'Master'
};

export const roleColors = {
  admin: 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300',
  agente: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300',
  aspirante: 'bg-violet-100 text-violet-800 dark:bg-violet-900 dark:text-violet-300',
  usuario: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
  asesor: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
  viewer: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
  developer: 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-300',
  asistente: 'bg-teal-100 text-teal-800 dark:bg-teal-900 dark:text-teal-300',
  master: 'bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-300'
};

// Líneas de negocio / Aseguradoras
export const businessLineLabels = {
  allianz: 'Allianz',
  qualitas: 'Qualitas',
  insignia: 'Insignia Life',
  flipping: 'Bienes Raíces'
};

export const businessLineColors = {
  allianz: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300',
  qualitas: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
  insignia: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300',
  flipping: 'bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-300'
};

// Estados de póliza
export const policyStatusColors = {
  active: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
  pending: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300',
  expired: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300',
  cancelled: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300'
};

export const policyStatusLabels = {
  active: 'Activa',
  pending: 'Pendiente',
  expired: 'Vencida',
  cancelled: 'Cancelada'
};
